import { Control, Controller, FieldValues, Path } from 'react-hook-form'

import { cn } from '@/lib/utils'
import { Input } from '../primitives/Input'
import { Label } from '../primitives/Label'

interface FormInputProps<T extends FieldValues> {
  control: Control<T>
  name: Path<T>
  label?: string
  placeholder?: string
  type?: 'text' | 'email' | 'password' | 'number' | 'tel' | 'url'
  rules?: Record<string, unknown>
  disabled?: boolean
  inputSize?: 'sm' | 'md' | 'lg' | 'xl'
  className?: string
  showLabel?: boolean
}

export function FormInput<T extends FieldValues>({
  control,
  name,
  label,
  placeholder,
  type = 'text',
  rules,
  disabled = false,
  inputSize = 'md',
  className,
  showLabel = true,
}: FormInputProps<T>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <div className={cn('flex flex-col gap-2', className)}>
          {showLabel && label && (
            <Label htmlFor={name} required={!!rules?.required}>
              {label}
            </Label>
          )}
          <Input
            {...field}
            disabled={disabled}
            error={!!fieldState.error}
            id={name}
            inputSize={inputSize}
            placeholder={placeholder}
            type={type}
          />
          {fieldState.error && (
            <span className="text-xs text-red-600">
              {fieldState.error.message}
            </span>
          )}
        </div>
      )}
      rules={rules}
    />
  )
}
